import store from "@/Plugins/Store";
import Vue from "vue";
import VueCookie from "vue-cookie";
import swal from 'sweetalert'

Vue.use(VueCookie)

swal.setDefaults({
  html: true,
  allowOutsideClick: true
})

export default {
  data() {
    return {
      rowtext: store.getters.rowtext,
      form_rules: store.getters.form_rules,
      packagetypes: store.getters.packagetypes,
      icons: store.getters.icons,
      popout: store.state.popout,
      offline: false,
      paginationList: [10, 20, 30]
    }
  },
  methods: {
    goTo(url, data = {}, opt = {}) {
      this.$inertia.get(url, data, opt)
    },
    _error(field, errorBag = 'default') {
      if (!this.$page.props.errors.hasOwnProperty(errorBag)) {
        return null;
      }

      if (this.$page.props.errors[errorBag].hasOwnProperty(field)) {
        return this.$page.props.errors[errorBag][field];
      }

      return null;
    },
    _changeMode() {
      this.$vuetify.theme.dark = !this.$vuetify.theme.dark;
      setTimeout(() => {
        if (this.$vuetify.theme.dark) {
          this.$cookie.set('prefers', 'dark')
          this.$cookie.set('mode', 'theme--dark')
        } else {
          this.$cookie.set('prefers', 'light')
          this.$cookie.set('mode', 'theme--light')
        }
      }, 200)
    },
    checkLogin () {
      let checked = this.$cookie.get('auto_login')
      if (!checked) {
        this.$cookie.set('auto_login', 'checked', { expires: '1m' })
      }
      if (window.PasswordCredential || window.FederatedCredential) {
        if (!this.$auth.getToken()) {
          navigator.credentials.get({
            password: true,
            mediation: 'optional'
          }).then(c => {
              // console.log('C ', c)
              if (c) {
                switch (c.type) {
                  case 'password':
                    return this.$auth.login(c);
                    break;
                  case 'federated':
                    // return gSignIn(c);
                    break;
                  }
              } else {
                  return Promise.resolve();
              }
          }).then(profile => {
              if (profile) {
                  // updateUI(profile);
                  // console.log('profile', profile)
              }
          }).catch(error => {
            console.error(error, 'ERROR');
            // let path = this.$route.fullpath
            // this.$router.push('/login?redirect=' + path)
          });
        }
      }
    },
    _reloadCurrent() {
      this.$inertia.reload({ preserveScroll: true, preserveState: true })
    },
    _deactivateUser(user) {
      swal({
        title: 'Deactivate User',
        text: 'Deactivate this user - <strong>' + user.email + '</strong>?<br>The user will not be able to login',
        type: 'warning',
        html: true,
        showCancelButton: true,
        confirmButtonColor: 'red',
        confirmButtonText: 'Deactivate',
      },
        function () {
          this.$inertia.put('/admin/users/' + user.id + '/deactivate', {}, {
            preserveScroll: false,
            preserveState: true,
          })
        }.bind(this))
    },
    _activateUser(user) {
      swal({
        title: 'User Activation',
        text: 'Activate this user - <strong>' + user.email + '</strong>?<br>User will now be able to login',
        type: 'warning',
        html: true,
        showCancelButton: true,
        confirmButtonColor: 'green',
        confirmButtonText: 'Activate'
      },
        function () {
          this.$inertia.put('/admin/users/' + user.id + '/activate', {}, {
            preserveScroll: false,
            preserveState: true,
          })
        }.bind(this))
    },
    _verify(user) {
      swal({
        title: user.email,
        text: 'Verify this account on behalf of the user',
        type: 'warning',
        showCancelButton: true,
        confirmButtonColor: 'red',
        confirmButtonText: 'Verify',
      },
        function () {
          this.$inertia.put('/admin/users/' + user.id + '/verify', null, {
            preserveScroll: true,
          })
        }.bind(this))
    },
    _unverify(user) {
      swal({
        title: user.email,
        text: 'Force the user to verify this email?',
        type: 'warning',
        showCancelButton: true,
        confirmButtonColor: 'red',
        confirmButtonText: 'Continue',
      },
        function () {
          this.$inertia.put('/admin/users/' + user.id + '/unverify', null, {
            preserveScroll: true,
          })
        }.bind(this))
    },
    _loginAs(user) {
      swal({
        title: 'Login as ' + user.email,
        text: 'You will also be logged out of your account',
        type: 'warning',
        showCancelButton: true,
        confirmButtonColor: 'red',
        confirmButtonText: 'Attempt Login',
      },
        function () {
          this.$inertia.post('/admin/users/login', { id: user.id }, {
            preserveScroll: true,
          })
        }.bind(this))
    },
    _changeCurrency(currency, forced = false) {
      if (this.can['currencies.default']) {
        if (forced) {
          this.$inertia.post('/currencies/' + currency.id + '/default', { default: !currency.default })
        } else {
          this.$message  = 'Currency <code>' + currency.code + '</code> is already the default'
        }
      } else {
        swal({ title: 'These are the currencies that you can use to pay.', type: 'success', timer: 7500 })
      }
    },
    poppedout(message) {
      console.log(message)
      this.popout = message
    },
    _getMode() {
      // console.warn('i have gotten mode');
      // _checkDarkMode()
      let vm = this
      var dark = window.matchMedia('(prefers-color-scheme: dark)')
      if (dark.matches) {
        vm.$cookie.set('mode', 'theme--dark')
        // document.cookie = "mode=theme--dark";
      }
      var light = window.matchMedia('(prefers-color-scheme: light)')
      if (light.matches) {
        vm.$cookie.set('mode', 'theme--light')
        // document.cookie = "mode=theme--light";
      }
      // console.log(dark, light);
      dark.onchange = function () {
        vm._checkDarkMode()
      }
      light.onchange = function () {
        vm._checkDarkMode()
      }
    },
    _checkDarkMode() {
      // console.log('theme checked!');
      var dark = window.matchMedia('(prefers-color-scheme: dark)')
      var light = window.matchMedia('(prefers-color-scheme: light)')
      if (dark.matches) {
        this.$cookie.set('mode', 'theme--dark')
        // document.cookie = "mode=theme--dark";
      }
      if (light.matches) {
        this.$cookie.set('mode', 'theme--light')
        // document.cookie = "mode=theme--light";
      }
      if (!light.matches && !dark.matches) {
        this.$cookie.set('mode', '')
        // document.cookie = "mode=";
      }
    },
    _getUser() {
      return new Promise((resolve, reject) => {
        axios.get('/api/user')
          .then(res => {
            resolve(res)
          })
          .catch(err => {
            reject(err)
          })
      })
    }
  },
  computed: {
    $title() {
      return 'Primacy Health'
    },
    $breakpoint() {
      // let breakpoint = ''
      return this.$vuetify.breakpoint
    },
    $notificationWidth () {
      switch (this.$breakpoint.name) {
        case 'xs':
          return '80vw';
          break;
        case 'sm':
          return '50vw';
          break;
        case 'md':
          return '40vw';
          break;
        case 'lg':
          return '30vw';
          break;
        default:
          return '50vw';
          break;
      }
    },
    $darkmode() {
      // let prefers = this.$cookie.get('prefers')
      // if (prefers && prefers == 'dark') {
      //   this.$vuetify.theme.dark = true
      //   return true
      // }
      // if (prefers && prefers == 'light') {
      //   this.$vuetify.theme.dark = false
      //   return false
      // } else {
      //   let mode = this.$cookie.get('mode')
      //   if (mode == 'theme--dark') {
      //     this.$vuetify.theme.dark = true
      //     return true
      //   } else {
      //     this.$vuetify.theme.dark = false
      //     return false
      //   }
      // }
    },
    can () {
      return this.$page.props.auth ? this.$page.props.auth.can : null
    },
    $user () {
      return this.$page.props.auth ? this.$page.props.auth.user : null
    },
    $admin() {
      return this.$user ? this.$user.is_admin : false
    },
    $errors() {
      return this.$page.props.errors
    },
    $messaged () {
      if (this.$message) {
        return true
      }
      return false
    },
    // $message() {
    //   let message = this.$page.props.message

    //   if (!message) {
    //     return ''
    //   }
    //   let random = Math.random().toString(36).substr(2, 5) + '-'
    //   return random + message
    // },
    $message: {
      get () {
        let message = this.$page.props.message

        if (!message) {
          return ''
        }
        let random = Math.random().toString(36).substr(2, 5) + '-'
        return random + message
      },
      set(value) {
        this.$page.props.message = '';
        let vm = this;
        setTimeout(function () {
          vm.$page.props.message = value;
        }, 300)
      }
    },
    previousRoute () {
      return this.$page.props.previous
    },
    getPrevious() {
      let origin = location.origin
      let previous = this.previousRoute
      return previous.replace(origin, '')
    },
    $currency() {
      return this.$page.props.default_currency
    },
    $currencies() {
      return this.$page.props.active_currencies
    },
    $notifications() {
      let notif = this.$page.props.notifications

      if (notif) {
        return notif;
      }
      return []
    },
    $default_settings() {
      return this.$page.props.default_settings
    }
  },
  mounted() {
    this.$nextTick(() => {
      // console.warn('mounted');
      this._getMode()
      let prefers = this.$cookie.get('prefers')
      if (prefers && prefers == 'dark') {
        this.$vuetify.theme.dark = true
        return true
      }
      if (prefers && prefers == 'light') {
        this.$vuetify.theme.dark = false
        return false
      } else {
        let mode = this.$cookie.get('mode')
        if (mode == 'theme--dark') {
          this.$vuetify.theme.dark = true
          return true
        } else {
          this.$vuetify.theme.dark = false
          return false
        }
      }
    })
    this.$once('hook:mounted', () => {
      let vm = this
      // connectivity
      window.addEventListener('offline', function (e) {
        // console.log('offline');
        vm.offline = true;
      });

      window.addEventListener('online', function (e) {
        // console.log('online');
        vm.offline = false;
      });
      let loader = document.getElementById('loading-indicator')
      loader?.remove()
    })
  }
}
